import { axiosInstance } from '../config';
import { getUserSession, getHeaders } from '../authentication';

export const getMeasurementsByFlauteIdAndBoxId = (flaute, box) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('measurements/byFlauteAndBox/' + flaute + '/' + box,config);
};
